<button mat-raised-button (click)="openDialog()">{{ content }}</button>
